import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import Binding from "../../../binding";
import MaintReq from "./MaintReq";
import MaintShipSelect from "./MaintShipSelect";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import PriorityIcon from "../../Misc/PriorityIcon";
import PriorityButton from "../../Misc/PriorityButton";

export default class MaintElements extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      pending: false,
      shipId: false,
      reqModalShow: false,
      reqElementId: null,
      reqItem: {},
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.itemId !== this.props.itemId) {
      this.load();
    }
  }

  load = async () => {
    this.setState({ pending: true });
    let filter = {
      documentid: this.props.itemId,
    };
    if (this.state.shipId) {
      filter.shipid = this.state.shipId;
    }
    let items = await this.context.api.qa("/maintenance/item/list", {
      filter,
    });
    this.setState({
      pending: false,
      items,
    });
  };

  onShipChange = (shipId) => {
    this.setState({ shipId }, () => this.load());
  };

  onElementPick = async (item) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/maintenance/item/set", {
      document: this.props.itemId,
      element: item.id,
    });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      this.load();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };

  onElementRemove = async (item) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/maintenance/item/delete", {
      document: this.props.itemId,
      itemid: item.itemid,
    });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      this.load();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };

  onElementReqOpen = (item) => {
    this.setState({
      reqModalShow: true,
      reqItem: item,
      reqElementId: item.elementid,
      reqElementName: item.element.modelname,
      reqDocumentName: item.document.label,
    });
  };

  onElementReqClose = () => {
    this.setState({ reqModalShow: false });
  };
  onAfterElementReqSave = () => {
    this.load();
  };

  render() {
    const { pending, items } = this.state;
    return (
      <>
        <MaintReq
          show={this.state.reqModalShow}
          onClose={this.onElementReqClose}
          onAfterSave={this.onAfterElementReqSave}
          elementId={this.state.reqElementId}
          elementName={this.state.reqElementName}
          itemId={this.props.itemId}
          itemName={this.state.reqDocumentName}
          manageMaint={this.props.manageMaint}
          data={this.state.reqItem}
        />
        <MaintShipSelect
          shipId={this.state.shipId}
          onChange={this.onShipChange}
        />

        <Blocker on={pending}>
          {items.map((item) => {
            let element = item.element || {};
            let binding = new Binding({ ...element, classcode: "element" });
            return (
              <div
                key={item.itemid}
                className="my-2 p-3 border d-flex justify-content-between align-items-center"
              >
                <Link
                  to={binding.url}
                  className="text-dark-75 text-hover-primary"
                >
                  {item.expired && (
                    <i
                      className="fa fa-clock-o mr-2 text-danger"
                      title="ТО просрочено"
                    ></i>
                  )}
                  {element.label}
                  <div className="text-dark-50 small">
                    <span className="mr-2 text-dark-75">
                      {element.shipname}
                    </span>
                    <span className="mr-2">{element.modelname}</span>
                    {item.meterperiod > 0 && (
                      <span className="mr-2">
                        <i className="fa fa-clock-o mr-1"></i>{" "}
                        {item.meterperiod}
                      </span>
                    )}
                    {item.scheduler && (
                      <span className="mr-2">
                        <i className="fa fa-calendar mr-1"></i>{" "}
                        {item.scheduler.name}
                      </span>
                    )}
                  </div>
                </Link>
                <div className="flex-shrink-0 ml-3">
                  <PriorityButton
                    setPath="/maintenance/item/set"
                    prepareData={({ id }) => {
                      return {
                        priority: id,
                        document: item.documentid,
                        itemid: item.itemid,
                      };
                    }}
                    onAfterChange={this.load}
                    label={element.label}
                    description={element.shipname}
                    className="btn btn-icon btn-light mr-2"
                    prioritycode={item.priority?.code}
                    priorityIcon={
                      <PriorityIcon
                        showAll
                        prioritycode={item.priority?.code}
                        priorityname={item.priority?.name}
                      />
                    }
                  />

                  <div
                    onClick={() =>
                      this.context.redirect(
                        `/act_maintenance/add/?maint=${this.props.itemId}&element=${element.id}`
                      )
                    }
                    title="Акт выполнения ТО"
                    className="btn btn-icon btn-light mr-2"
                  >
                    <i className="fa fa-check-square-o"></i>
                  </div>
                  <div
                    className="btn btn-icon btn-light mr-2"
                    onClick={() => this.onElementReqOpen(item)}
                  >
                    <i className="fa fa-list"></i>
                  </div>
                  <div
                    className="btn btn-icon btn-light"
                    onClick={() => this.onElementRemove(item)}
                  >
                    <i className="fa fa-trash"></i>
                  </div>
                </div>
              </div>
            );
          })}
          {!items.length ? (
            <DefaultNotFound
              message={
                <div>
                  Для данного ТО нет оборудования{" "}
                  <div
                    className="btn btn-sm btn-light ml-2"
                    onClick={() =>
                      this.props.onElementPickOpen(
                        this.onElementPick,
                        this.state.shipId
                      )
                    }
                  >
                    Добавить
                  </div>
                </div>
              }
            />
          ) : (
            <>
              {this.props.manageMaint && (
                <div className="mt-5 pt-5 border-top">
                  <div className="d-flex justify-content-between">
                    <div>
                      <div
                        className="btn btn-primary"
                        onClick={() =>
                          this.props.onElementPickOpen(
                            this.onElementPick,
                            this.state.shipId
                          )
                        }
                      >
                        Добавить оборудование
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </Blocker>
      </>
    );
  }
}
